import React from "react";
import { CircularProgress } from "@mui/material";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const AccountReports = () => {
  const [plans, setPlans] = React.useState(null);

  const fetchStats = async () => {
    const { data } = await Axios({
      method: "get",
      url: "/api/activity/accountreports",
    });
    setPlans(data.data);
  };
  const navigate = useNavigate();
  React.useEffect(() => {
    fetchStats();
  }, []);
  if (plans === null) {
    return <CircularProgress />;
  }
  return (
    <>
      <div className="container admin-user-activity">
        <h3>Reported Accounts</h3>
        {plans?.length > 0 ? (
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr className="plan_thead_tr plan_tr">
                <th className="plan_thead_tr plan_td">Reported User</th>
                <th className="plan_thead_tr plan_td">Reporter</th>
                <th className="plan_thead_tr plan_td">Reported at</th>
                <th className="plan_thead_tr plan_td">Attachment</th>
                <th className="plan_thead_tr plan_td">Suspicious/Scam</th>
                <th className="plan_thead_tr plan_td">
                  Harassment/Hateful speech
                </th>
                <th className="plan_thead_tr plan_td">Adult content</th>
                <th className="plan_thead_tr plan_td">
                  Property Infringement/Defamation
                </th>
                <th className="plan_thead_tr plan_td">Other</th>
              </tr>
            </thead>
            <tbody className="plan_tbody">
              {plans.map((plan) => (
                <tr key={plan._id} className="plan_tbody_tr plan_tr">
                  <td className="plan_tbody_td plan_td">
                    <div
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${plan.reportedUser?._id}`
                        )
                      }
                      className="d-flex plan_tbody_logo align-items-center pointer"
                    >
                      {plan.reportedUser ? (
                        <>
                          <img src={plan?.reportedUser?.avatar} alt="logo" />
                          <div>
                            <p className="m-0">
                              {plan?.reportedUser?.name
                                ? plan?.reportedUser?.name
                                : `${plan?.reportedUser?.firstname} ${plan?.reportedUser?.lastname}`}
                            </p>
                            <p className="m-0 mt-8">{`${plan?.reportedUser?.email} (${plan?.reportedUser?.type})`}</p>
                          </div>
                        </>
                      ) : (
                        "Not Found"
                      )}
                    </div>
                  </td>
                  <td className="plan_tbody_td plan_td">
                    <div
                      onClick={() =>
                        navigate(
                          `/admin/user-activity?tab=13&userid=${plan.reporter?._id}`
                        )
                      }
                      className="d-flex plan_tbody_logo align-items-center pointer"
                    >
                      {plan.reporter ? (
                        <>
                          <img src={plan?.reporter?.avatar} alt="logo" />
                          <div>
                            <p className="m-0">
                              {plan?.reporter?.name
                                ? plan?.reporter?.name
                                : `${plan?.reporter?.firstname} ${plan?.reporter?.lastname}`}
                            </p>
                            <p className="m-0 mt-8">{`${plan?.reporter?.email} (${plan?.reporter?.type})`}</p>
                          </div>
                        </>
                      ) : (
                        "Not Found"
                      )}
                    </div>
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {returnDate(plan?.createdAt)}
                  </td>
                  <td className="plan_tbody_td plan_td">
                    <img
                      height={50}
                      width={100}
                      src={plan?.attachement}
                      alt="logo"
                    />
                  </td>{" "}
                  <td className="plan_tbody_td plan_td">
                    {plan.suspiciousOrSpam?.join(", ")}
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {plan.harassmentOrHatfulSpeech?.join(", ")}
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {plan.adultContent?.join(", ")}
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {plan.ipiOrdefamation?.join(", ")}
                  </td>
                  <td className="plan_tbody_td plan_td">
                    {plan.otherActivity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <h2>No Reports</h2>
        )}
      </div>
    </>
  );
};

export default AccountReports;
